var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#00c769;}.cls-3{fill:#00ad5b;}.cls-4{fill:#31e38e;}.cls-5{fill:#00305f;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.8c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8A610.7,610.7,0,0,0,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.8,1291.5,1551.8,1068.5,1551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,411.3A610.4,610.4,0,0,0,659.9,531.7a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,686.1,1363.9,411.3,1025,411.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1339.4,
    cy: 698.8,
    rx: 30.8,
    ry: 52.8,
    transform: "translate(396.9 1879.5) rotate(-79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1235.1,
    cy: 718.7,
    rx: 17.2,
    ry: 25,
    transform: "translate(-4.9 1429) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M883.3,1096.4a29.9,29.9,0,0,1-21.2-8.7L700.6,926.2A30,30,0,1,1,743,883.7l161.5,161.5a30,30,0,0,1-21.2,51.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M721.8,1096.4a30,30,0,0,1-21.2-51.2L862.1,883.7a30,30,0,0,1,42.4,42.5L743,1087.7A29.9,29.9,0,0,1,721.8,1096.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1166.7,1096.4a30,30,0,0,1-21.2-51.2L1307,883.7a30,30,0,0,1,42.4,42.5l-161.5,161.5A29.9,29.9,0,0,1,1166.7,1096.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1328.2,1096.4a29.9,29.9,0,0,1-21.2-8.7L1145.5,926.2a30,30,0,0,1,42.4-42.5l161.5,161.5a30,30,0,0,1-21.2,51.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1192.9,1343.8c-31.6,0-49.2-14.2-60.8-23.6-9.1-7.3-12.8-10.4-23.1-10.4s-14.1,3.1-23.1,10.4c-11.7,9.4-29.3,23.6-60.9,23.6s-49.2-14.2-60.9-23.6c-9-7.3-12.7-10.4-23.1-10.4s-14.1,3.1-23.1,10.4c-11.6,9.4-29.2,23.6-60.8,23.6s-49.2-14.2-60.9-23.6c-9-7.3-12.7-10.4-23.1-10.4a30,30,0,0,1,0-60c31.6,0,49.2,14.3,60.9,23.7,9,7.3,12.7,10.3,23.1,10.3s14.1-3,23.1-10.3c11.6-9.4,29.2-23.7,60.8-23.7s49.3,14.3,60.9,23.7c9,7.3,12.7,10.3,23.1,10.3s14.1-3,23.1-10.3c11.6-9.4,29.2-23.7,60.9-23.7s49.2,14.3,60.8,23.7c9,7.3,12.7,10.3,23.1,10.3s14.1-3,23.1-10.3c11.7-9.4,29.3-23.7,60.9-23.7a30,30,0,0,1,0,60c-10.4,0-14.1,3.1-23.1,10.4C1242.1,1329.6,1224.5,1343.8,1192.9,1343.8Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFear);
export default __webpack_public_path__ + "static/media/fear.c33c7a3e2e3f827a3a95cf1c7f530dbd.svg";
export { ForwardRef as ReactComponent };